import { useState } from 'react';
import { Anchor, Footer as BaseFooter, Text, useMantineColorScheme } from '@mantine/core';
import { useIntlLight } from '../../libs/i18n';
import useStyles from './Footer.styles';
import { ValidUseTermContainer } from '../../libs/ui-molecules';
import useAuth from '../../hooks/useAuth';

export default function Footer() {
  const { colorScheme } = useMantineColorScheme();
  const isDarkMode = colorScheme === 'dark';
  const { classes } = useStyles();
  const { t } = useIntlLight();
  const [showUseTerm, setShowUseTerm] = useState(false);
  const { loggedIn, hasUser, isImpersonating } = useAuth();

  return (
    <BaseFooter className={classes.footer} height={170} p="md" withBorder>
      <Text>
        <ul className={classes.copyRightUl}>
          <li className={classes.copyRightLi}>
            <Anchor
              href="https://www.mapaq.gouv.qc.ca/fr/Avis/Pages/Politique.aspx"
              target="_blank"
              rel="noreferrer"
            >
              {t('footer_politique')}
            </Anchor>
          </li>
          <li className={classes.copyRightLi}>
            <Anchor onClick={() => setShowUseTerm(true)}>{t('footer_condition')}</Anchor>
          </li>
        </ul>
      </Text>
      {loggedIn && hasUser && !isImpersonating && (
        <ValidUseTermContainer
          useTermType="UTILISATEUR"
          showModal={showUseTerm}
          closeModal={() => setShowUseTerm(false)}
        />
      )}
      <a className="" href="https://www.quebec.ca/" target="_blank" rel="noreferrer">
        <img
          className={classes.logoQC}
          src={isDarkMode ? '/image/QUEBEC_blanc.svg' : '/image/QUEBEC_couleur.svg'}
          alt=""
        />
      </a>
      <Text color="dimmed" size="sm">
        {t('home.copyright', { year: `${new Date().getFullYear()}` })}
      </Text>
      <Text color="dimmed" size="sm">
        Version : {process.env.REACT_APP_VERSION}
      </Text>
    </BaseFooter>
  );
}
